'use strict';

const callHandlers = (fns, args) => {
  fns.forEach(handler => handler(args));
};

class FetchHandler {
  constructor({
    completeHandlers,
    successHandlers,
    errorHandlers,
    requestOpts = {},
    url,
  }) {
    this.url = url;

    this.requestOpts = requestOpts;
    if (!(this.requestOpts.headers instanceof Headers)) {
      this.requestOpts.headers = new Headers();
    }
    this.requestOpts.headers.append('X-Requested-With', 'XMLHttpRequest');
    this.requestOpts.headers.append('Accept', 'application/json');
    this.requestOpts.headers.append('Accept', 'text/html');

    this.completeHandlers = [];
    this.successHandlers = [];
    this.errorHandlers = [];
    this.setHandlers({ completeHandlers, successHandlers, errorHandlers });

    this.fetchInFlight = false;
  }

  setHandlers({
    completeHandlers = [],
    successHandlers = [],
    errorHandlers = [],
  }) {
    this.completeHandlers = this.completeHandlers.concat(completeHandlers);
    this.successHandlers = this.successHandlers.concat(successHandlers);
    this.errorHandlers = this.errorHandlers.concat(errorHandlers);
  }

  send(data) {
    if (this.fetchInFlight) {
      return;
    }

    const hasBody = data !== undefined || this.requestOpts.body !== undefined;

    const opts = Object.assign({}, this.requestOpts);

    if (hasBody) {
      Object.assign(opts, {
        body: JSON.stringify(Object.assign({}, this.requestOpts.body, data)),
      });
      opts.headers.set('Content-Type', 'application/json');
    }

    const request = new Request(this.url, opts);

    this.fetchInFlight = true;
    return fetch(request)
      .then(response => {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error(
            `FetchHandler: request received error with status ${
              response.status
            }`
          );
        }
      })
      .then(this.handleSuccess.bind(this))
      .catch(
        (e => {
          if (this.errorHandlers.length) {
            return this.handleError(e);
          } else {
            throw e;
          }
        }).bind(this)
      )
      .then(this.handleComplete.bind(this));
  }

  handleComplete() {
    callHandlers(this.completeHandlers);
    this.fetchInFlight = false;
  }

  handleSuccess(response) {
    callHandlers(this.successHandlers, response);
  }

  handleError(error) {
    callHandlers(this.errorHandlers, error);
  }
}

module.exports = FetchHandler;
